import { RemoteRecurringPushNotificationGetById } from 'data/usecases';
import { RecurringPushNotificationGetByIdUseCaseInterface } from 'domain/usecases/push-notification/recurring-push-notification-get-by-id';
import { makeApiUrlRecurringPushNotification } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRecurringPushNotificationGetById =
  (): RecurringPushNotificationGetByIdUseCaseInterface =>
    new RemoteRecurringPushNotificationGetById(
      makeApiUrlRecurringPushNotification(),
      makeAxiosHttpClient(),
    );
